import React from 'react';
import { NewsfilateFooter } from '../components/NewsfilateFooter';
import { Link } from 'react-router-dom';
import { LayoutDashboardIcon, FoldersIcon, TrendingUpIcon } from 'lucide-react';
export function NewsfilateUpdatePage() {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-1795">
      {/* Logo only header */}
      <header className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-sm border-b border-gray-100" data-id="element-1796">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1797">
          <div className="flex items-center justify-between h-16" data-id="element-1798">
            <div className="flex items-center" data-id="element-1799">
              <Link to="/products/newsfiliate" className="flex-shrink-0" data-id="element-1800">
                <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/3eb2f218-c9ff-4fe6-ad82-ebadfcc155d3/Nf_final.png" alt="Newsfiliate Logo" className="h-8" data-id="element-1801" />
              </Link>
            </div>
          </div>
        </div>
      </header>
      <main className="flex-grow pt-8 pb-16" data-id="element-1802">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1803">
          {/* Hero Section */}
          <div className="bg-white rounded-2xl shadow-md p-8 md:p-12 mb-12 relative overflow-hidden" data-id="element-1804">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#5e60ce]/10 rounded-full -mr-32 -mt-32" data-id="element-1805"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#5e60ce]/5 rounded-full -ml-48 -mb-48" data-id="element-1806"></div>
            <div className="relative" data-id="element-1807">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6" data-id="element-1808">
                What's New in Newsfiliate 🎉
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl" data-id="element-1809">
                We've rolled out some exciting updates to help you earn more,
                save time, and make your emails even more beautiful and
                personal. Here's what's new:
              </p>
            </div>
          </div>
          {/* New Homepage Layout */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden mb-12" data-id="element-1810">
            <div className="p-8" data-id="element-1811">
              <div className="flex items-center mb-6" data-id="element-1812">
                <div className="bg-[#5e60ce] p-3 rounded-lg mr-4" data-id="element-1813">
                  <LayoutDashboardIcon className="h-6 w-6 text-white" data-id="element-1814" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-1815">
                  New Homepage Layout
                </h3>
              </div>
              <p className="text-gray-600 mb-6" data-id="element-1816">
                Navigate seamlessly between the Newsletter Lists, Collections, and
                AI Trend Discovery that you've created on the homepage. Our new layout makes it
                easier than ever to access all your content and discover new
                products.
              </p>
              <div className="mt-4 flex justify-center" data-id="element-1817">
                <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/3eb2f218-c9ff-4fe6-ad82-ebadfcc155d3/Untitled_design_%288%29.gif" alt="New Homepage Layout Demo" className="max-w-full md:max-w-[80%] h-auto rounded-lg shadow-md" data-id="element-1818" />
              </div>
            </div>
          </div>
          {/* Collections */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden mb-12" data-id="element-1819">
            <div className="p-8" data-id="element-1820">
              <div className="flex items-center mb-6" data-id="element-1821">
                <div className="bg-[#5e60ce] p-3 rounded-lg mr-4" data-id="element-1822">
                  <FoldersIcon className="h-6 w-6 text-white" data-id="element-1823" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-1824">Collections</h3>
              </div>
              <p className="text-gray-600 mb-6" data-id="element-1825">
                Organize your product recommendations like a pro. Now you can
                create Collections to group products by niche, season, or type
                and easily track deals, discover related items, and drop them
                straight into your newsletters.{' '}
                <a href="https://newsfiliate.creatorboost.ai/doc/newsfiliate-help?page=product-collections" className="text-[#5e60ce] font-medium hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-1826">
                  Learn more here
                </a>
              </p>
              <div className="mt-4 flex justify-center" data-id="element-1827">
                <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/3eb2f218-c9ff-4fe6-ad82-ebadfcc155d3/11.png" alt="Collections Feature" className="max-w-full md:max-w-[80%] h-auto rounded-lg shadow-md" data-id="element-1828" />
              </div>
            </div>
          </div>
          {/* AI Trend Discovery */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden mb-12" data-id="element-1829">
            <div className="p-8" data-id="element-1830">
              <div className="flex items-center mb-6" data-id="element-1831">
                <div className="bg-[#5e60ce] p-3 rounded-lg mr-4" data-id="element-1832">
                  <TrendingUpIcon className="h-6 w-6 text-white" data-id="element-1833" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-1834">
                  AI Trend Discovery
                </h3>
              </div>
              <p className="text-gray-600 mb-6" data-id="element-1835">
                We're introducing an all-new AI product discovery experience
                built just for creators. Our AI scans your content to build a
                Creator Profile, capturing your niche, audience, and tone, and
                uses it to find trending products your followers will actually
                love.{' '}
                <a href="https://newsfiliate.creatorboost.ai/doc/newsfiliate-help?page=trend-discovery" className="text-[#5e60ce] font-medium hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-1836">
                  Learn more here
                </a>
              </p>
              <div className="mt-4 flex justify-center" data-id="element-1837">
                <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/3eb2f218-c9ff-4fe6-ad82-ebadfcc155d3/12.png" alt="AI Trend Discovery Feature" className="max-w-full md:max-w-[80%] h-auto rounded-lg shadow-md" data-id="element-1838" />
              </div>
            </div>
          </div>
          {/* Closing Message */}
          <div className="bg-[#5e60ce] rounded-xl shadow-md p-8 text-white" data-id="element-1839">
            <div data-id="element-1840">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1841">
                We'd love to hear what you think!
              </h2>
              <p className="text-white/90 text-lg" data-id="element-1842">
                These updates are all about giving you more control, more
                flexibility, and more ways to grow your affiliate revenue with
                less hassle.
              </p>
            </div>
          </div>
        </div>
      </main>
      <NewsfilateFooter data-id="element-1843" />
    </div>;
}